import {
  Avatar,
  Card,
  // CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  // IconButton,
  useTheme,
} from '@mui/material';
import { Text } from '../Text/Text';
// import FavoriteIcon from '@mui/icons-material/Favorite';
import { toTimeAndDate } from '../../utils/toTimeAndDate';
import {
  avatarSx,
  cardContentSx,
  cardSx,
  timeSx,
  titleSx,
} from './FeedPost.style';
import { headerActionBtnSx, marginBottom16Sx } from '../../styles/Global.style';
import { IconBtn } from '../IconBtn/IconBtn';
import { ModalContainer } from '../../containers/ModalContainer/ModalContainer';
import { Confirmation } from '../Confirmation/Confirmation';
import { useState } from 'react';
import { Copy } from '../../copy/Copy';
import { deletePost } from '../../helpers/deletePost';
import { useAuth } from '../../hooks/useAuth/useAuth';
import { Delete } from '../../icons/Delete/Delete';

export const FeedPost = ({
  postId,
  userId,
  name,
  content,
  img,
  // likes,
  created,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const toggleDeleteModal = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    await deletePost({
      jwt: user?.jwt,
      postId,
    });
    location.reload();
  };

  return (
    <>
      <Card sx={cardSx(theme)}>
        <CardHeader
          avatar={
            <Avatar sx={avatarSx(theme)} aria-label="Poster's avatar">
              {name.charAt(0)}
            </Avatar>
          }
          action={
            userId === user?.id && (
              <IconBtn
                icon={<Delete sx={headerActionBtnSx} />}
                aria-label="Delete post"
                onClick={toggleDeleteModal}
                color={theme.palette.secondary.main}
              />
            )
          }
          title={name}
          sx={titleSx(theme)}
        />
        <CardContent sx={cardContentSx}>
          <Text text={content} sx={marginBottom16Sx} />

          {img && (
            <CardMedia
              component="img"
              height="194"
              image={img}
              alt="Post image"
              sx={marginBottom16Sx}
            />
          )}

          <Text variant="body2" text={toTimeAndDate(created)} sx={timeSx} />
        </CardContent>

        {/* <CardActions>
          <IconButton aria-label="like post">
            <FavoriteIcon sx={{ color: 'red' }} />
          </IconButton>
          <Text text={likes} sx={font700Sx} />
        </CardActions> */}
      </Card>

      <ModalContainer isOpen={isDeleteModalOpen} onClose={toggleDeleteModal}>
        <Confirmation
          title={Copy.generate('Global.areYouSure')}
          content={Copy.generate('FeedPost.deleteModal.content')}
          acceptBtnText={Copy.generate('Buttons.delete')}
          declineBtnText={Copy.generate('Buttons.back')}
          accept={handleDelete}
          decline={toggleDeleteModal}
        />
      </ModalContainer>
    </>
  );
};
